import { useQuery } from '@tanstack/react-query'
import { httpGetVisualVettingScore } from '@/features/luxe-submissions/http/luxe-submissions.http'

export const VISUAL_VETTING_SCORE_QUERY_KEY = 'visual-vetting-score'

export const useGetVisualVettingScore = (listingId: string, enabled: boolean) =>
	useQuery({
		queryKey: [VISUAL_VETTING_SCORE_QUERY_KEY, { listingId }],
		queryFn: () => httpGetVisualVettingScore(listingId),
		enabled
	})
